import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { api, errorMessage } from '@/lib/api';
import { GdprNoticeSection } from '@/components/GdprNoticeSection';
import { InnovationSectionEditor } from '@/components/InnovationSectionEditor';

export const Route = createFileRoute('/_authed/settings')({
  component: SettingsPage,
});

function SettingsPage() {
  const settingsQ = useQuery({
    queryKey: ['app-settings'],
    queryFn: () => api.getSettings(),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-h1">Settings</h1>

      {settingsQ.isLoading ? (
        <div className="card text-slate-gray">Loading settings…</div>
      ) : settingsQ.isError ? (
        <div className="card text-error">{errorMessage(settingsQ.error)}</div>
      ) : settingsQ.data ? (
        <>
          <GdprNoticeSection settings={settingsQ.data.settings} />
          <InnovationSectionEditor settings={settingsQ.data.settings} />
        </>
      ) : null}

      <div className="card space-y-3 text-slate-gray">
        <p>
          Project: <span className="font-mono text-dark-navy">Explorentia</span> ·
          region <span className="font-mono text-dark-navy">eu-central-1</span> · env
          <span className="font-mono text-dark-navy"> dev</span>
        </p>
      </div>
    </div>
  );
}
